import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useStyles } from '../styles';
import PropTypes from 'prop-types';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import CustomTableMetricOption from './CustomTableMetricOption/CustomTableMetricOption';
import { containsSubString, isEmpty } from '../utils';
import { useSelector } from 'react-redux';
import {
	ECOMMERCE,
	IN_STORE,
	enumToColumnNames,
	OMNI,
	ECOM,
	STORE,
} from '../../../constants/constant';
function CustomTableMetric(props) {
	const {
		name,
		index,
		metrics,
		parentCallback,
		searchText,
		channel,
		defaultOpen,
		segment_id,
	} = props;
	const classes = useStyles();
	const [arrowSelect, setArrowSelect] = useState(false);

	const userPreferences = useSelector((state) => state.columnReducer);
	const [options, setOptions] = useState([]);

	const handleSelection = (metric, checked) => {
		let options_array = [...options];
		if (checked) {
			options_array = [...options, metric];
		} else {
			options_array?.splice(options.indexOf(metric), 1);
		}
		setOptions(options_array);
		parentCallback(name, metric, checked, segment_id);
	};

	const handleSelect = () => {
		setArrowSelect(true);
	};

	const closeDropdown = () => {
		setArrowSelect(false);
	};

	useEffect(() => {
		// This will open the metrics accordions in the Tour guide last step
		if (defaultOpen) {
			// eslint-disable-next-line no-undef
			setInterval(() => setArrowSelect(true), 100);
		}
	}, [defaultOpen]);

	// eslint-disable-next-line
	const getAllMetrics = (filter) => {
		let tempList = [];
		let columnsArr = userPreferences?.columnList;
		if (isEmpty(columnsArr)) {
			return [];
		}
		columnsArr[filter][index]?.metrics?.forEach((metric) => {
			tempList.push(metric.name);
		});
		return tempList;
	};

	const setActiveList = () => {
		let activeList = [];
		let metrics = {};
		let selected_channel;

		// Get saved preferences object
		const userPrefs = userPreferences?.userPreferenceList;
		if (userPrefs !== null && userPrefs !== undefined) {
			if (Object.keys(userPrefs).length > 0) {
				metrics = userPrefs;
			}
		}

		// Transform back the dropdown channel name to ENUM
		switch (channel) {
			case IN_STORE:
				selected_channel = STORE;
				break;
			case ECOMMERCE:
				selected_channel = ECOM;
				break;
			default:
				selected_channel = OMNI;
		}

		// Iterate over all channels in saved preferences object
		if (Object.keys(metrics).length > 0) {
			for (const [key, value] of Object.entries(metrics)) {
				// Check if the channel is the one we're looking for
				if (key === selected_channel.toUpperCase()) {
					// Iterate over all segments in the channel
					value?.map((segments) => {
						if (segments.id === segment_id) {
							// Iterate over all metrics in the segment
							segments.metrics?.map((metric) => {
								// Add to active list
								activeList.push(metric?.shortName);
							});
						}
					});
				}
			}
		}
		return activeList;
	};

	useEffect(() => {
		setOptions(setActiveList());
		closeDropdown();
	}, [metrics]);

	useEffect(() => {
		setActiveList();
	});

	return (
		<Box className={classes.table_metricBorder}>
			<Box className={classes.tableCategory}>
				{/* Dropdown Icon */}
				<Box
					className={classes.table_dropdownIcon}
					data-test-id="ctc-metric-dropdown">
					{arrowSelect || (searchText != null && searchText?.length > 0) ? (
						<KeyboardArrowDownIcon onClick={closeDropdown} />
					) : (
						<KeyboardArrowRightIcon onClick={handleSelect} />
					)}
				</Box>
				{/* Metric */}
				<Box>
					<Typography className={classes.tableCategoryText}>{name}</Typography>
				</Box>
				{/* Selection Number */}
				<Box className={classes.table_categoryNumberContainer}>
					{metrics != null ? (
						<Typography className={classes.tableCategoryNumber}>
							{options.length + '/' + metrics.length}
						</Typography>
					) : null}
				</Box>
			</Box>

			{(arrowSelect || (searchText != null && searchText?.length > 0)) &&
			metrics != null ? (
				<>
					{metrics?.map((metric, index) => {
						if (
							searchText == '' ||
							(searchText != '' &&
								containsSubString(
									enumToColumnNames[metric['shortName']],
									searchText
								))
						) {
							return (
								<CustomTableMetricOption
									key={index}
									//name={metric['name']} // Default metric name
									name={enumToColumnNames[metric['shortName']]} // Workaround to show local name mapping from UI
									parentCallback={handleSelection}
									searchText={searchText}
									metric={name}
									channel={channel}
									options={options}
									shortName={metric['shortName']}></CustomTableMetricOption>
							);
						}
					})}
				</>
			) : null}
		</Box>
	);
}

CustomTableMetric.propTypes = {
	name: PropTypes.string.isRequired,
	index: PropTypes.number.isRequired,
	metrics: PropTypes.array.isRequired,
	channel: PropTypes.string.isRequired,
	parentCallback: PropTypes.func,
	searchText: PropTypes.string,
	defaultOpen: PropTypes.bool,
	segment_id: PropTypes.string.isRequired,
};

export default CustomTableMetric;
